export function leadPhoneError(value) {
  let phone = value.replace(/[\s()-]/g, "");
  if (phone.startsWith("00")) phone = "+" + phone.slice(2);
  if (/^0[0-9]{10}$/.test(phone)) phone = "+90" + phone.slice(1);
  if (/^5[0-9]{9}$/.test(phone)) phone = "+90" + phone;
  if (!/^\+[1-9][0-9]{6,14}$/.test(phone)) return "Telefonu ülke koduyla yazın: +90 500 000 00 00";
  if (phone.startsWith("+90") && !/^\+90[1-9][0-9]{9}$/.test(phone)) return "Türkiye numarasında +90 sonrasında 10 rakam olmalı.";
  return "";
}
